/* eslint-disable no-console */
import React, { Component } from 'react';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// our components
import { NOTIFICATION_CATEGORY } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import { Mutation } from 'components/common/Query';
import NotificationCategoryForm from 'components/NotificationCategory/Form';

/**
 * Mutation to create a notification category
 */
export const CREATE_NOTIFICATION_CATEGORY_MUTATION = gql`
  mutation($name: String!, $order: Int!, $description: String!) {
    createNotificationCategory(
      input: { name: $name, order: $order, description: $description }
    ) {
      notificationCategory {
        id
        __typename
      }
      errors {
        field
        messages
        __typename
      }
      clientMutationId
      __typename
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class NotificationCategoryCreateContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.Compose = adopt({
      mutateNotificationCategoryCreate: this.notificationCategoryCreate,
    });
  }

  /**
   * @description
   * Mutation callback to compose with list query.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  notificationCategoryCreate = ({ render }) => (
    <Mutation
      mutation={CREATE_NOTIFICATION_CATEGORY_MUTATION}
      onCompleted={this.notificationCategoryCreateCompleted}
    >
      {(handleNotificationCategoryCreate, { loading }) =>
        render({ handleNotificationCategoryCreate, loadingCreate: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation callback when create notification category is completed.
   *
   * @param {Object} createNotificationCategory - Mutation result.
   */
  notificationCategoryCreateCompleted = async ({
    createNotificationCategory,
  }) => {
    const history = this.context;
    const { errors } = createNotificationCategory;
    if (!errors) {
      history.push(NOTIFICATION_CATEGORY.LIST);
    } else {
      this.setState({ errors });
    }
  };

  /**
   * @description
   * Close notification.
   * @returns {undefined} - No returns value.
   */
  handleCloseNotification = () => {
    this.setState({ errors: [] });
  };

  /**
   * @description
   * Render NotificationCategoryForm component.
   *
   * @returns {*} Component to render.
   */
  render() {
    const { errors } = this.state;
    return (
      <this.Compose>
        {({
          mutateNotificationCategoryCreate: {
            handleNotificationCategoryCreate,
            loadingCreate,
          },
        }) => (
          <NotificationCategoryForm
            notificationCategorySave={notificationCategory =>
              handleNotificationCategoryCreate({
                variables: notificationCategory,
              })
            }
            errors={errors}
            submitLoading={loadingCreate}
            closeNotification={this.handleCloseNotification}
          />
        )}
      </this.Compose>
    );
  }
}

export default NotificationCategoryCreateContainer;
